import React from 'react'
import {Link} from 'react-router-dom'
import classNames from 'classnames';
import {Collapse} from 'react-collapse'

class HamburgerMenuAccordion extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      accordionOpen: false,
    }
  }

  handleToggleAccordion = () => {
    this.setState({
      accordionOpen: !this.state.accordionOpen,
    })
  }

  handleLinkSelect = (id, title, url) => {
    this.setState({
      accordionOpen: false,
    })

    if (this.props.onLinkSelect) {
      this.props.onLinkSelect(id, title, url)
    }
  }

  render () {
    return (
      <div className={classNames(
        'slidein__accordion',
        {'slidein__accordion--open': this.state.accordionOpen},
        {'slidein__accordion--closed': !this.state.accordionOpen}
      )}>
        <button
          className='slidein__section'
          onClick={this.handleToggleAccordion}
          type="button"
        >
          {this.props.title}
        </button>
        <Collapse isOpened={this.state.accordionOpen}>
          <ul className='slidein__expanded'>
            {this.props.links.map(({id, url, title}) => {
              return (
                <li key={id}>
                  <Link to={url} onClick={() => this.handleLinkSelect(id, title, url)} tabIndex={this.state.accordionOpen ? 0 : -1}>
                    <h3>{title}</h3>
                  </Link>
                </li>
              )
            })}
          </ul>
        </Collapse>
      </div>
    )
  }
}

export default HamburgerMenuAccordion
